import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import React from 'react';
import { StepTypography } from '@fingo/lib/components/typography';
import { useSkualoOfferShoppingCart } from '../../../hooks/offer-shopping-cart';

const SkualoCessionInstructions = ({ bankId, setBankId }) => {
  const { paragraphs, loading } = useSkualoOfferShoppingCart({
    bankId,
    setBankId,
  });

  if (loading) {
    return <Skeleton variant="rectangular" width="100%" height={100} />;
  }

  return (
    <Stack px={3} pb={3} spacing={3}>
      {paragraphs.map(({ id, title, content }) => (
        <Stack key={id} spacing={1}>
          <StepTypography stepNumber={id}>{title}</StepTypography>
          {content}
        </Stack>
      ))}
    </Stack>
  );
};

SkualoCessionInstructions.propTypes = {
  bankId: PropTypes.string.isRequired,
  setBankId: PropTypes.func.isRequired,
};

export default SkualoCessionInstructions;
